import { createStore, combineReducers } from 'redux';
import { productsReducer } from './reducers/reducers';
import { addedItems } from './reducers/addedItems';
import { favouriteProducts} from './reducers/addedItems';
const root = combineReducers({
    allprodcuts:productsReducer,
    chosenProducts:addedItems,
    favouriteProducts
})

const store = createStore(root,
    window.__REDUX_DEVTOOLS_EXTENSION__ &&  window.__REDUX_DEVTOOLS_EXTENSION__()
)

export default store
